import Joi from 'joi-browser';
import _ from 'lodash';
import regex from '../utilities/validateRegex';
import { localize, localizeMessage } from './validateMessage';

export class input {
  constructor(form) {
    //console.log("input");
    this.form = form;
  }

  /**
   * フォーム並び替えされる要素のセレクタ名
   * @param {string} targetSelecter
   */
  setFormComponent(targetSelecter) {
    this.targetSelecter = targetSelecter;
  }

  /**
   * inputイベントのコールバック
   * @param {function} func
   */
  setEventCallback(func) {
    this.eventCallback = func;
  }

  /**
   * バリデートのコールバック
   * @param {function} func
   */
  setValidateCallback(func) {
    this.validateCallback = func;
  }

  setValue(val) {
    this.order = null;
    this.data = val;
    this.self = this.form.getFormElementByName(this.data.name);
    this.self.value = val.value || '';
    this.schema = val.schema;
    this.component = this.getFormListElement(this.self.parentElement);

    if (this.component) {
      this.message = this.component.querySelector('.form-list__alert');
    }

    //スキーマのあるときだけイベントをアタッチ
    const _schema = _.filter(val.schema._inner.children, vali => {
      return vali.key == this.data.name;
    });

    if (_schema.length) {
      //console.log("バリデートイベント ");

      this.addEvent(e => {
        if (this.eventCallback) {
          this.eventCallback(e);
        }

        this.validateMessage(null);
        let param = {};
        param[this.data.name] = e.target.value;

        //バリデート設定
        //console.log("バリデート設定 " , param);

        this.validate(param, result => {
          //正規表現を設定している場合
          if (_.has(regex, 'pattern')) {
            let _pattern = '';
            _.each(regex.pattern, (value, key) => {
              if (`${value}` == `${result.context.pattern}`) {
                _pattern = key;
              }
            });
            this.validateMessage(result, regex.message[_pattern]);
          } else {
            //正規表現設定していない場合
            this.validateMessage(result, null);
          }
          if (this.validateCallback) {
            this.validateCallback(result);
          }
        });
      });
    }
  }

  addEvent(func) {
    this.self.addEventListener(this.eventType, e => {
      func(e);
    });
  }

  /**
   * 並び順
   * @param { string } n
   */
  setOrder(n) {
    if (!n) {
      this.component.innerHTML = '';
      this.component.style.display = 'none';
      return;
    }
    this.order = n;
    this.component.style.order = n;
  }

  /**
   * メッセージ表示
   * @param { object } result
   */
  validateMessage(result, message) {
    if (result) {
      //joiを置き換え
      const joi = result.message.match(/\[(.*)\]/i);
      this.message.classList.add('show');
      this.message.innerText = message ? message : localizeMessage[joi[1]];
    } else {
      this.message.classList.remove('show');
      this.message.innerText = '';
    }
  }

  /**
   * バリデート
   * @param { object } param
   * @param { function } callbakc
   */
  validate(param, callback) {
    const result = Joi.validate(param, this.schema, {
      abortEarly: false,
      language: localize,
    });
    if (result.error) {
      result.error.details.forEach(detail => {
        _.each(detail.path, val => {
          if (val == this.data.name) {
            callback(detail);
          }
        });
      });
    }
  }

  /**
   * 自分のフォームリスト要素を取得
   * @param { dom } element
   */
  getFormListElement(element) {
    //console.log("getFormListElement ----- " , this.targetSelecter ,element ,this.data);
    const selecter = this.targetSelecter.match(/.(.*)/i)[1];

    if (!element) {
      return null;
    } else if (element.classList.contains(selecter)) {
      return element;
    } else {
      return this.getFormListElement(element.parentElement);
    }
  }
}

export class text extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'keyup';
    //console.log("text");
  }
}

export class textarea extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'keyup';
    //console.log("textarea");
  }
}

export class password extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'keyup';
    //console.log("password");
  }
}

export class hidden extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'change';
    //console.log("hidden");
  }
}

export class select extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'change';
    //console.log("select");
  }
}

export class radio extends input {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'change';
    //console.log("ラジオ" , this.form );
  }

  setValue(val) {
    this.data = val;
    _.each(this.form.getFormElementByNameAll(this.data.name), item => {
      //console.log("ラジオをセット" , item ,item.value , this.data.value);
      if (item.value == this.data.value) {
        item.checked = true;
      }
    });
    this.self = this.form.getFormElementByName(this.data.name);
    this.schema = val.schema;
    this.component = this.getFormListElement(this.self.parentElement);

    //console.log("ラジオを設定" , this.self , val.schema );

    //スキーマのあるときだけイベントをアタッチ
    const _schema = _.filter(val.schema._inner.children, val => {
      return val.key === this.data.name;
    });

    if (_schema.length) {
      //console.log("ラジオにバリデートを設定" , this.self );
      this.self.addEventListener('change', e => {
        let param = {};
        param[this.data.name] = e.target.value;
        this.validate(param, result => {
          this.validateMessage(result);
        });
      });
    }
  }
}

export class checkbox extends radio {
  constructor(form) {
    super();
    this.form = form;
    this.eventType = 'change';
    //console.log("checkbox");
  }

  setValue(val) {
    this.data = val;
    _.each(this.form.getFormElementByNameAll(this.data.name), item => {
      _.each(this.data.value, value_item => {
        if (item.value == value_item) {
          item.checked = true;
        }
      });
    });
    this.self = this.form.getFormElementByName(this.data.name);
    this.schema = val.schema;
    this.component = this.getFormListElement(this.self.parentElement);

    //スキーマのあるときだけイベントをアタッチ
    const _schema = _.filter(val.schema._inner.children, val => {
      return val.key === this.data.name;
    });

    if (_schema.length) {
      this.self.addEventListener('change', e => {
        let param = {};
        param[this.data.name] = e.target.value;
        this.validate(param, result => {
          this.validateMessage(result);
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/inputObjects.js